import { ICellRendererParams } from 'ag-grid-community';
import { getEnvConfig } from '../../../config/config';
import styles from './opponents.module.scss';

interface IOpponent {
  person: {
    personID: string;
    nativeFamilyName: string;
    nativeGivenName: string;
  };
}

const OpponentsCell = ({ value }: Partial<ICellRendererParams>) => {
  const teamUrl = getEnvConfig().teamUrl;

  if (!value?.opponent) return null;

  return value?.opponent?.map((opponent: IOpponent, index: number) => {
    const nativeGivenName =
      opponent.person?.nativeGivenName !== 'UNKNOWN' ? opponent.person?.nativeGivenName : 'Player';

    return value?.schoolId && opponent.person?.personID ? (
      <a
        data-testid="PT-opponentCell-teamLink"
        key={index}
        className={styles.opponent}
        href={`${teamUrl}${value.schoolId}&a=Index&c=VenueTeam&s=/Player/${opponent.person.personID}`}
        title={`${opponent.person.nativeGivenName} ${opponent.person.nativeFamilyName}`}
      >
        <span>{opponent.person.nativeGivenName}</span>
        <span className={styles.opponentFamilyName}>{opponent.person.nativeFamilyName}</span>
      </a>
    ) : (
      <div key={index} className={`${styles.opponent} ${styles.nonLinkedOpponent}`}>
        <span>{nativeGivenName}</span>
        {opponent.person?.nativeFamilyName !== 'UNKNOWN' ? (
          <span className={styles.opponentFamilyName}>{opponent.person.nativeFamilyName}</span>
        ) : null}
      </div>
    );
  });
};

export { OpponentsCell };
